import httpClient from '../../../httpClient'

const SYSTEM_ENDPOINT = 'v3/system'

const getSettings = () => httpClient(`${SYSTEM_ENDPOINT}/settings/actual?token=${process.env.VUE_APP_SETTINGS_KEY}`)

export { getSettings }
